// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__1f7Zj","paymentContainer":"PaymentPage_paymentContainer__1RW8_"};